'use strict'

module.exports =

  set: ->
    nextHref = $("ul.pagination-links li.selected")?.next()?.find('a')?.attr('href')
    prevHref = $("ul.pagination-links li.selected")?.prev()?.find('a')?.attr('href')
    if nextHref
      @linkNext = @_setLink(nextHref, @linkNext, "next")
    else if @linkNext
      @linkNext.remove()
    if prevHref
      @linkPrev = @_setLink(prevHref, @linkPrev, "prev")
    else if @linkPrev
      @linkPrev.remove()

  _setLink: (href, oldLink, relValue) ->
    host = window.location.protocol + '//' + window.location.hostname
    linkNode = $("<link rel=#{relValue} href=#{host}#{href}>")
    oldLink?.remove()
    $('head').append(linkNode)
    return linkNode
